<gp-modal [closable]="true" #templateConditionsModal size="md">
  <div class="gp-modal-title" test-id="conditions-modal-title">
    <h5>
      {{ 'TEMPLATE.insert_conditions' | translate }}
    </h5>
  </div>
  <div class="gp-modal-body">
    <form novalidate [formGroup]="templateConditionsForm" class="gp-modal-body clearfix">
      <div class="col-md-12">
        <div class="form-group">
          <label for="field"> {{ 'TEMPLATE.field' | translate }}
            <span class="required"> *</span>
          </label>

          <gp-tree-select
            [attr.test-id]="'field-list' | gpTestId: 'template-conditions-modal'"
            (elementSelected)="onFieldsSelect($event)"
            [tree]="fieldListTree"
            class="form-control"
            formControlName="fieldName"
            id="field"
            ngDefaultControl>
          </gp-tree-select>

          <em *ngIf="selectedFieldItem?.path" class="text-muted" test-id="field-path">({{ selectedFieldItem?.path }}
            )</em>
        </div>
        <div class="form-group">
          <label for="operator"> {{ 'TEMPLATE.operator' | translate }}
            <span class="required"> *</span>
          </label>
          <gp-dropdown-select
            #templateConditionsOperatorDropdown
            (click-outside)="templateConditionsOperatorDropdown.open = false"
            [attr.test-id]="'operator' | gpTestId: 'template-conditions-modal'"
            buttonClasses="btn-sm"
            class="form-control no-b"
            formControlName="operator"
            id="operator"
            ngDefaultControl>
            <gp-dropdown-option *ngFor="let operator of operators"
                                [ngValue]="operator.value">
              {{ operator.display | translate }}
            </gp-dropdown-option>
          </gp-dropdown-select>
        </div>
        <div class="form-group">
          <label> {{ 'TEMPLATE.value' | translate }}
            <span class="required" *ngIf="valueToCompareFieldEnabled"> *</span>
          </label>
          <input *ngIf="!selectedFieldItem || !valueToCompareFieldEnabled; else dynamicInputPanel"
                 class="form-control"
                 id="readOnlyText"
                 readOnly="true"
                 type="text"/>
          <ng-template #dynamicInputPanel>
            <ng-container [ngSwitch]="selectedFieldItem?.fieldType">
              <gp-tree-select *ngSwitchCase="'LIST'"
                              [attr.test-id]="'list' | gpTestId: 'template-conditions-modal'"
                              [isSorted]="true"
                              [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                              [tree]="selectedFieldItem.metaData"
                              class="form-control"
                              formControlName="valueToCompare"
                              id="valueToCompareList"
                              ngDefaultControl>
              </gp-tree-select>

              <gp-tree-select *ngSwitchCase="'TREE'"
                              [attr.test-id]="'tree' | gpTestId: 'template-conditions-modal'"
                              [isSorted]="true"
                              [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                              [tree]="selectedFieldItem.metaData"
                              class="form-control"
                              formControlName="valueToCompare"
                              id="valueToCompareTree"
                              ngDefaultControl>
              </gp-tree-select>

              <gp-tree-select *ngSwitchCase="'ENTITY'"
                              [attr.test-id]="'entity' | gpTestId: 'template-conditions-modal'"
                              [isSorted]="true"
                              [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                              [tree]="selectedFieldItem.metaData"
                              class="form-control"
                              formControlName="valueToCompare"
                              id="valueToCompareEntity"
                              ngDefaultControl>
              </gp-tree-select>

              <datepicker-input *ngSwitchCase="'DATE'"
                                [attr.test-id]="'date' | gpTestId: 'template-conditions-modal'"
                                [(ngModel)]="currentDate"
                                [hasEternity]="true"
                                [isAppendToBody]="false"
                                id="comparisonDate"
                                formControlName="valueToCompare"
                                ngDefaultControl>
              </datepicker-input>

              <number-input
                *ngSwitchCase="selectedFieldItem?.fieldType | isNumericFieldType"
                [attr.test-id]="'filter-input' | gpTestId: 'template-conditions-modal'"
                [classes]="['filter-input-field', 'form-control', 'add-value-control']"
                [maxDigits]="selectedFieldItem?.fieldType === payValueType ? 10 : 2"
                [type]="selectedFieldItem?.fieldType === 'INTEGER' ? 'integer' : 'decimal'"
                formControlName="valueToCompare"
                ngDefaultControl>
              </number-input>

              <input *ngSwitchDefault
                     class="filter-input-field  form-control add-value-control"
                     formControlName="valueToCompare"
                     id="valueToCompareTextInput"
                     type="text"/>

            </ng-container>
          </ng-template>
        </div>
        <div class="form-group">
          <label for="trueResult"> {{ 'TEMPLATE.when_true' | translate }}
            <span class="required"> *</span>
          </label>
          <textarea type="text"
                    [rows]="2"
                    class="textarea-control"
                    formControlName="trueResult"
                    id="trueResult"></textarea>
        </div>
        <div class="form-group">
          <label for="falseResult">{{ 'TEMPLATE.when_false' | translate }}
          </label>
          <textarea type="text"
                    [rows]="2"
                    class="textarea-control"
                    formControlName="falseResult"
                    id="falseResult"></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="onSubmit()"
                class="btn btn-dark p-x-md"
                [disabled]="templateConditionsForm?.invalid"
                test-id="btnInsertCondition">
          <em class="fa fa-light fa-save p-x-xs"></em>
          {{ 'TEMPLATE.insert' | translate }}
        </button>
        <button (click)="templateConditionsModal.close()"
                type="button"
                class="btn btn-secondary p-x-md"
                test-id="btnCancel">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
